import { api } from '../../api';

export const claimPrem90 = async () => {
  const url = 'v1/wallet/prem/90/claim';
  try {
    return await api.put(url);
  } catch (err) {
    return console.error('Claim prem 90 err', err);
  }
};
